import { CommonModule } from "@angular/common";
import { Component, Inject, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserStoryDetailViewComponent } from "../../modal-templates/user-story-detail-view/user-story-detail-view.component";
import { SharedComponents } from "../../shared.module";

/**
 * The `TestReviewComponent` is responsible for reviewing test data. It displays information about tests
 * and provides the ability to view more details for each item in a modal dialog.
 */
@Component({
  selector: "app-test-review",
  standalone: true,
  imports: [CommonModule, ...SharedComponents],
  templateUrl: "./test-review.component.html",
  styleUrl: "./test-review.component.scss",
})
export class TestReviewComponent {
  sectionData: any;
  private modalService = inject(NgbModal);

  /**
   * Constructor for `TestReviewComponent`. It injects the step data to populate the test review data
   * and initializes the component.
   * @param data - The data passed from the parent component or service (injected as "STEP_DATA").
   */
  constructor(@Inject("STEP_DATA") public data: any) {}

  /**
   * Opens a modal dialog to display more detailed information about the selected test review item.
   * The modal displays a `UserStoryDetailViewComponent` with additional information about the item.
   * @param item - The test review item for which more details are to be displayed.
   */
  moreDetails(item: any) {
    console.log("Item==>", item);
    const modalRef = this.modalService.open(UserStoryDetailViewComponent, {
      centered: true,
      windowClass: "user-story-modal",
      size: "xl",
      backdrop: 'static',
    });
    modalRef.componentInstance.data = {
      testReview: item,
    };
    modalRef.result.then((result) => {
      console.log(result);
    });
  }

  downloadCSV() {
    console.log("download csv");
  }
}
